/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Event { 
    readonly id?: string;
    type: string;
    readonly player?: string;
    readonly created?: string;
    readonly updated?: string;
}

